import { Actor, Engine, vec, PointerEvent, CollisionType } from 'excalibur';
import { EventsManager } from '@game-libs/events-manager';
import { GameplayEvents } from '../types/game-events';
import { dummyAnimation } from './animations';
import { DamageSource, GUIActions } from '../types/game-types';
import { HitEffect } from './hitEffect';
import { BaseLevel } from './baseLevel';
import { Images } from './resources';

export class Dummy extends Actor {
  private dummySprite = new Actor({
    collisionType: CollisionType.PreventCollision,
  });
  private isDead = false;

  constructor() {
    super({
      collisionType: CollisionType.PreventCollision,
      width: 32,
      height: 32,
      anchor: vec(0.5, 1),
    });

    this.scale = vec(4, 4);

    this.z = this.pos.y + 10;
  }

  onAdd(engine: Engine): void {
    const { on, emit } = EventsManager();

    const shadow = new Actor({
      width: 100,
      height: 100,
      collisionType: CollisionType.PreventCollision,
    });
    shadow.scale = vec(0.07, 0.07);
    shadow.graphics.use(Images.UnderShadow.toSprite());
    this.addChild(shadow);
    shadow.pos.y -= 3;
    shadow.z = 0;

    on(GUIActions.DUMMY_KILLED, () => {
      this.isDead = true;
      // Play death animation then remove from scene
      const deathAnimation = dummyAnimation.hard_hit.clone();
      this.dummySprite.graphics.use(deathAnimation);
      this.actions.fade(0, 1000).die();
    });

    on(GameplayEvents.DAMAGE_DRAGON, ({ isCritical: isCriticalHit, source }) => {
      if (this.isDead) return;

      if (source === DamageSource.Click) {
        const hitPosition = (engine.currentScene as BaseLevel).getAttackTargetPosition(vec(0, -40));
        const hitEffect = new HitEffect(hitPosition, isCriticalHit);
        this.scene?.add(hitEffect);

        // Play hit animation based on damage
        const hitAnimation = isCriticalHit ? dummyAnimation.mid_hit.clone() : dummyAnimation.weak_hit.clone();
        this.dummySprite.graphics.use(hitAnimation);
        hitAnimation.events.once('end', () => {
          this.dummySprite.graphics.use(dummyAnimation.idle);
        });
      } else {
        const hitAnimation = dummyAnimation.weak_hit.clone();
        this.dummySprite.graphics.use(hitAnimation);
        hitAnimation.events.once('end', () => {
          this.dummySprite.graphics.use(dummyAnimation.idle);
        });
      }
    });

    this.dummySprite.graphics.use(dummyAnimation.idle);
    this.dummySprite.anchor.setTo(0.5, 1);
    this.addChild(this.dummySprite);

    // Attach pointer events to parent actor for NW.js compatibility
    // In NW.js, pointer events on child actors may not work correctly
    this.on('pointerdown', (evt: PointerEvent) => {
      if (this.isDead) return;

      emit(GameplayEvents.CLICK_GAME_DRAGON);
    });

    this.on('pointerup', (evt: PointerEvent) => {
      if (this.isDead) return;
      emit(GameplayEvents.STOP_CLICK_GAME_DRAGON);
    });

    this.on('pointerleave', (evt: PointerEvent) => {
      if (this.isDead) return;
      emit(GameplayEvents.STOP_CLICK_GAME_DRAGON);
    });
  }
}
